import { render, staticRenderFns } from "./GeofencingNotifications.vue?vue&type=template&id=0f30fffa"
import script from "./GeofencingNotifications.vue?vue&type=script&lang=js"
export * from "./GeofencingNotifications.vue?vue&type=script&lang=js"
import style0 from "./GeofencingNotifications.vue?vue&type=style&index=0&id=0f30fffa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports